import { render, staticRenderFns } from "./Suffix.vue?vue&type=template&id=09923e6c&scoped=true&lang=pug&"
import script from "./Suffix.vue?vue&type=script&lang=js&"
export * from "./Suffix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09923e6c",
  null
  
)

export default component.exports